import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProgramList, SubjectList } from "../interface/AdvancedFilterReponse";
export interface SubjectOption {
  label: string;
  data: SubjectList | "ALL";
  selected: boolean;
}

interface AdvancedFilterState {
  gradedProgram: ProgramList[];
  subjects: SubjectOption[];
  selectedProgram: ProgramList | null;
  selectedSubject: SubjectOption | null;
  selectedToggle: any;
  is_graded_quiz: boolean;
  hasJozunaSkills: boolean | null;
}

const initialState: AdvancedFilterState = {
  gradedProgram: [],
  subjects: [],
  selectedProgram: null,
  selectedSubject: null,
  selectedToggle: "Pop-Quiz",
  is_graded_quiz: false,
  hasJozunaSkills: null,
};

const advancedFilterGradedPopquixSlice = createSlice({
  name: "advancedFilter",
  initialState,
  reducers: {
    setgradedProgram(state, action: PayloadAction<ProgramList[]>) {
      state.gradedProgram = action.payload;
    },
    setSubjects(state, action: PayloadAction<SubjectOption[]>) {
      state.subjects = action.payload;
    },
    setSelectedProgram(state, action: PayloadAction<ProgramList | null>) {
      state.selectedProgram = action.payload;
      state.selectedSubject = null; // reset subject when program changes
    },
    setSelectedSubject(state, action: PayloadAction<SubjectOption | null>) {
      state.selectedSubject = action.payload;
    },
    resetFilter(state) {
      state.selectedProgram = state.gradedProgram[0] || null;
      state.selectedSubject = state.subjects[0] || null;
    },
    toggleSubject: (state, action) => {
      const index = action.payload;

      // Select All
      if (index === 0) {
        const isSelected = !state.subjects[0].selected;

        state.subjects = state.subjects.map((item) => ({
          ...item,
          selected: isSelected,
        }));

        state.selectedSubject = null;
        return;
      }

      // Single select
      state.subjects = state.subjects.map((item, idx) => ({
        ...item,
        selected: idx === index,
      }));

      state.selectedSubject = state.subjects[index];
    },

    setSelectedToggle: (state, action) => {
      state.selectedToggle = action.payload;
    },
    setIsGradedQuiz: (state, action) => {
      state.is_graded_quiz = action.payload;
    },
    setHasJozunaSkills: (state, action: PayloadAction<boolean>) => {
      state.hasJozunaSkills = action.payload;
    },
  },
});

export const {
  setgradedProgram,
  setSubjects,
  setSelectedProgram,
  setSelectedSubject,
  resetFilter,
  setSelectedToggle,
  toggleSubject,
  setIsGradedQuiz,
  setHasJozunaSkills,
} = advancedFilterGradedPopquixSlice.actions;

export default advancedFilterGradedPopquixSlice.reducer;
